<template>
  <div
    class="c-message-header"
    :class="{
      'c-message-header--success': success,
      'c-message-header--error': error
    }"
  >
    <div class="c-message-header__icon">
      <o-icon :icon="icon" size="large" />
    </div>
    <h2 class="c-message-header__text">{{ text }}</h2>
  </div>
</template>

<script>
export default {
  name: 'OMessageHeader',
  props: {
    icon: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.c-message-header {
  background: $background-color;
  padding: 2.4rem 1.6rem;
  text-align: center;
}

.c-message-header--success {
  background: $background-color-success;
  color: #fff;
}

.c-message-header__icon {
  background: #fff;
  border-radius: 50%;
  color: $primary-color;
  color: var(--primary-color);
  display: flex;
  height: 6.4rem;
  margin: 0.8rem auto 1.6rem;
  width: 6.4rem;

  & > * {
    margin: auto;
  }

  .c-message-header--success & {
    color: $green;
  }

  .c-message-header--error & {
    color: $red;
  }
}

.c-message-header__text {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 2.8rem;
}
</style>
